<template>
  <!-- 首页 -->
  <section id="home" class="page-section bg-white pt-32 pb-20 relative bg-gradient-to-b from-white to-light-gray">
    <div class="container mx-auto px-6 md:px-12 relative z-10 flex-grow">
      <div class="about-container">
        <div class="flex flex-col items-center">
          <!-- 文字内容区域 -->
          <div class="w-full max-w-2xl text-center">
            <!-- 核心标语：逐字浮现+渐变流动+粒子环绕 -->
            <div class="particle-container mb-8">
              <h1 id="core-slogan" class="text-[clamp(2.8rem,10vw,5.5rem)] font-bold leading-tight text-glow" />
            </div>
            <p class="text-md md:text-2xl mb-10 text-reveal" style="animation-delay: 2.5s;">
              九鱼乐将持续打造足以触动心灵的游戏记忆，让每一位玩家都能在我们的作品里，找到热爱的归属感与新鲜感。
            </p>
            <div class="flex flex-col sm:flex-row justify-center gap-4 mb-12 text-reveal" style="animation-delay: 3s;">
              <a
                href="#games"
                class="bg-gradient-to-r from-primary to-secondary text-white px-8 py-4 rounded-full font-medium text-center md:text-lg transition-all hover:opacity-90"
              >
                产品列表
              </a>
              <a
                href="#news"
                class="gradient-border text-dark-text px-8 py-4 rounded-full font-medium text-center transition-all hover:bg-light-gray md:text-lg"
              >
                最新动态
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <a href="/index#games">
      <!-- pc端下滑提示 - 鼠标样式 -->
      <div id="pc_mouse" class="absolute bottom-10 left-1/2 transform -translate-x-1/2 text-reveal" style="animation-delay: 3.5s;">
        <div class="scroll-mouse">
          <span class="scroll-tooltip">向下滚动探索更多</span>
        </div>
      </div>

      <!-- 移动端向下滚动指示 -->
      <div class="md:hidden absolute bottom-10 text-center transform -translate-x-1/2 text-reveal" style="animation-delay: 3.5s; left: 46%">
        <div class="scroll-arrows">
          <div class="scroll-arrow" />
          <div class="scroll-arrow" />
          <div class="scroll-arrow" />
        </div>
      </div>
    </a>
  </section>
</template>

<script>
export default {
  name: 'About',
  mounted() {
    // 核心标语逐字动画实现
    const sloganText = '只做创意好游戏为热爱而来'
    const sloganElement = document.getElementById('core-slogan')
    const container = sloganElement.parentElement

    // 清空容器并添加文字
    sloganElement.innerHTML = ''

    // 拆分文字并添加动画
    for (let i = 0; i < sloganText.length; i++) {
      const charSpan = document.createElement('span')
      charSpan.textContent = sloganText[i]
      charSpan.classList.add('char-item')
      // 为每个字符设置递增的动画延迟，形成逐字出现效果
      charSpan.style.animationDelay = `${0.15 * i}s`

      // 为"无限可能"添加特殊样式
      if (i >= 2 && i <= 6) {
        charSpan.classList.add('bg-gradient-to-r', 'from-primary', 'to-secondary', 'text-gradient')
      }

      sloganElement.appendChild(charSpan)
    }

    // 创建粒子效果
    createParticles(container, 13)

    // 创建粒子效果
    function createParticles(container, count) {
      for (let i = 0; i < count; i++) {
        const particle = document.createElement('div')
        particle.classList.add('particle')

        // 随机大小和位置
        const size = Math.random() * 15 + 5
        particle.style.width = `${size}px`
        particle.style.height = `${size}px`
        particle.style.left = `${Math.random() * 100}%`
        particle.style.top = `${Math.random() * 100}%`
        particle.style.animationDelay = `${Math.random() * 5}s`
        particle.style.animationDuration = `${Math.random() * 6 + 6}s`

        container.appendChild(particle)
      }
    }

    // 滚动动画增强
    const animateOnScroll = () => {
      const elements = document.querySelectorAll('.text-reveal:not([data-animated="true"])')
      elements.forEach(element => {
        const elementTop = element.getBoundingClientRect().top
        const elementVisible = 150

        if (elementTop < window.innerHeight - elementVisible) {
          element.setAttribute('data-animated', 'true')
          // 添加额外的强调效果
          setTimeout(() => {
            element.classList.add('animate-pulse-slow')
            setTimeout(() => {
              element.classList.remove('animate-pulse-slow')
            }, 1000)
          }, 500)
        }
      })
    }

    window.addEventListener('scroll', animateOnScroll)
    // 初始加载时检查
    animateOnScroll()
  }
}
</script>

<style scoped>
/* 内容容器上下左右居中 */
.about-container {
  /* 设置为flex布局 */
  display: flex;
  /* 水平方向居中 */
  justify-content: center;
  /* 垂直方向居中 */
  align-items: center;
  /* 让容器占满整个视口高度（确保垂直居中生效） */
  height: 80vh;

  @media (max-width: 800px) {
    margin-bottom: -2.8rem;
  }
}

/* 放大h1文字 */
.about-container h1 {
  @media (max-width: 800px) {
    font-size: 2.5rem;
  }
  @media (min-width: 800px) {
    font-size: 5.5rem;
  }
  font-weight: bold;
}

#pc_mouse {
  @media (max-width: 800px) {
    display: none;
  }
  @media (min-width: 800px) {
    visibility: visible;
  }
}
</style>
